import React from 'react';
import E911AddressModal from '../E911AddressModal/E911AddressModal';
import { useWifiCallingData } from 'lib/hooks/sim/sim.queries';
import { SimType } from 'types/shared';

type E911AddressProps = {
  iccid: string;
  simType: SimType;
};

/**
 * Displays the e911 address for a given ICCID.
 *
 * @description
 * * It will not render anything if the SIM is not of type `SimType.SPR`.
 * * It will render
 *   * e911 address if available
 *   * a button that opens a modal to edit the e911 address
 *   * "N/A" if the e911 address is not available or wifi calling is not enabled
 */
function E911Address({ iccid, simType }: E911AddressProps) {
  const [isWifiCallingModalOpen, setIsWifiCallingModalOpen] =
    React.useState(false);

  const { data, isLoading: isWifiCallingDetailsLoading } = useWifiCallingData({
    iccid,
  });

  if (simType !== SimType.SPR) return null;

  const { enabled, e911Address } = data ?? {};

  const { street1, street2, city, state, zip } = e911Address ?? {};

  const renderContent = () => {
    if (isWifiCallingDetailsLoading) return 'Loading...';

    if (enabled)
      return (
        <>
          {street1} {street2}
          <br />
          {city} {state}, {zip}
        </>
      );

    if (!enabled) return 'N/A';
  };

  return (
    <>
      <div className="info-block">
        <label className="label-text">e911 Address</label>

        <span
          onClick={() => setIsWifiCallingModalOpen(true)}
          className="btn-view-apn ml-3"
        >
          {enabled ? 'Edit Address' : 'Add Address'}
        </span>

        <p className="text-desc">{renderContent()}</p>
      </div>

      <E911AddressModal
        iccid={iccid}
        isOpen={isWifiCallingModalOpen}
        onClose={() => setIsWifiCallingModalOpen(false)}
      />
    </>
  );
}

export default E911Address;
